import { render } from "./IPViews.vue?vue&type=template&id=664f2360"
import script from "./IPViews.vue?vue&type=script&lang=js"
export * from "./IPViews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__